export default __webpack_public_path__ + "static/media/Icons.70c6148e.svg";